import $ from "jquery";
import Cookies from "js-cookie";

const $cookiesEl = $(".cookies");
const $cookiesBar = $(".cookies__bar");
const $cookiesConsent = $(".cookies-consent");
const $cookiesDecline = $(".cookies-decline");
const $cookiesConsentAll = $(".cookies__consent_all");
const $cookiesConsentCustom = $(".cookies__consent_custom");
const $cookiesCategoryMore = $(".cookies__category.icon-more");
const $cookiesSwitch = $(".checkbox-switch__input");

$(function () {
  const cookie_cnsnt = Cookies.get("cookie_cnsnt");

  if (cookie_cnsnt === undefined) {
    $cookiesBar.slideUp(0).slideDown(300).addClass("active");
    $("#cookies-focus").focus();
  } else {
    initCookieFunctions(cookie_cnsnt);
  }

  $cookiesConsent.on("click", function () {
    acknowledgeCookies(true);
    $cookiesBar.removeClass("active").slideUp(300);
  });
  $cookiesConsentAll.on("click", function () {
    acknowledgeCookies(true);
    $cookiesBar.removeClass("active").slideUp(300);
  });
  $cookiesDecline.on("click", function () {
    Cookies.set("cookie_cnsnt", "required", { expires: 90 });
    $cookiesBar.slideUp();
  });
  $cookiesConsentCustom.on("click", function () {
    acknowledgeCookies();
    $cookiesBar.removeClass("active").slideUp(300);
  });
  $cookiesSwitch.on("click", function (event) {
    if ($(this).data("group")) {
      let group = $(this).data("group");
      let groupChecked = 0;
      $(`.checkbox-switch__input[data-group=${group}]`).each(function () {
        if ($(this).prop("checked")) groupChecked = 1;
      });
      let parent = $(`.checkbox-switch__input[data-parent=${group}]`);
      if (groupChecked)
        parent.each(function () {
          $(this)[0].checked = true;
        });
      else
        parent.each(function () {
          $(this)[0].checked = false;
        });
    } else if ($(this).data("parent")) {
      let parent = $(this).data("parent");
      let checked = $(this).prop("checked");
      $(`.checkbox-switch__input[data-group=${parent}]`).each(function () {
        $(this)[0].checked = checked;
      });
    }
  });
  $cookiesCategoryMore.on("click", function (event) {
    console.log(event.target.nodeName);
    if (
      event.target.nodeName === "INPUT" ||
      event.target.nodeName === "SPAN" ||
      event.target.nodeName === "A"
    )
      return;
    let closestOpener = $(event.target).closest(".icon-more");
    if (closestOpener.hasClass("open")) {
      openMore(closestOpener, false);
      closestOpener.removeClass("open");
    } else {
      openMore(closestOpener);
      closestOpener.addClass("open");
    }
  });
});

function openMore(elem, open = true) {
  if (!open) {
    let moreContainer = elem.find(".more-container");
    if (moreContainer.length === 0) return;

    moreContainer.each(function () {
      if (open) $(this).show(300);
      else $(this).hide(300);
    });
  } else {
    let moreContainer = elem.children().children(".more-container");

    if (!moreContainer) return;

    if (open) moreContainer.show(300);
    else moreContainer.hide(300);
  }
}
function acknowledgeCookies(all = false) {
  // if (Cookies.get('cookie_cnsnt') !== undefined) return;

  let categories = [];

  if (all === true) {
    $cookiesEl.find(".checkbox-switch__input").each(function () {
      categories.push($(this).data("category"));
    });
  } else {
    $cookiesEl.find(".checkbox-switch__input:checked").each(function () {
      categories.push($(this).data("category"));
    });
  }

  categories = categories.join(",");
  Cookies.set("cookie_cnsnt", categories, { expires: 90 });

  initCookieFunctions(categories);
}

function initCookieFunctions(cookie_cnsnt) {
  const categories = cookie_cnsnt.split(",");

  categories.forEach(function (category) {
    switch (category) {
      case "analytics":
        initGoogleAnalytics();
        break;
    }
  });

  if (!categories.includes("analytics")) {
    disableGoogleAnalytics();
  }
}

function initGoogleAnalytics() {
  $cookiesEl.find(`[data-category=analytics]`).prop("checked", true);

  gtag("consent", "update", {
    analytics_storage: "granted",
  });
}

function disableGoogleAnalytics() {
  gtag("consent", "update", {
    analytics_storage: "denied",
  });
}

function gtag() {
  dataLayer.push(arguments);
}
